export const certifications = [
  {
    id: 1,
    title: 'AI Governance',
    organization: 'Saïd Business School, University of Oxford',
    issued: 'Apr 2026',
    credentialId: 'DXCIIJ2GR4QB',
    skills: 'AI Governance · Risk Management · Ethical AI · Human Oversight',
    url: '#',
  },
  {
    id: 2,
    title: 'AI & Law',
    organization: 'Lund University',
    issued: 'May 2026',
    credentialId: 'OR1OWWLQT52L',
    skills: 'AI & Law · Legal Frameworks · Governance · Responsible AI',
    url: '#',
  },
  {
    id: 3,
    title: 'HubSpot Sales Software',
    organization: 'HubSpot',
    issued: 'Mar 2026',
    expires: 'Apr 2027',
    credentialId: '668a52a35a7d49f68d44f2fae5e9789',
    skills: 'Enterprise Software · CRM Strategy · Revenue Operations · Sales Enablement',
    url: '#',
  },
  {
    id: 4,
    title: 'Registered Federal Contractor',
    organization: 'U.S. Federal Government',
    issued: 'Dec 2025',
    credentialId: 'SAM-UEI Registered',
    skills: 'Federal Contracting · Compliance · Public Sector · Government Services',
    url: '#',
  },
];

export const education = [
  {
    id: 1,
    institution: 'Georgia Southern University',
    degree: "Bachelor's Degree",
    field: 'Sport Management',
    period: 'Aug 2018 – Jul 2021',
    notes: 'Minor: Marketing / Management',
  },
  {
    id: 2,
    institution: 'Valdosta State University',
    degree: 'Business Administration and Management',
    field: 'General',
    period: 'Aug 2017 – May 2018',
  },
];

export const recommendations = [
  {
    id: 1,
    name: 'Akif Wani',
    role: 'AI Automation Expert & Top Rated Web Developer',
    relation: 'December 20, 2025, Jeff was Akif\'s client',
    endorsement:
      'I recommend Jeff based on the time I reported directly to him across multiple projects. He\'s clear with expectations, decisive when things need to move fast, and always focused on getting results without unnecessary noise. Jeff understands the big picture but stays involved where it matters most. He\'s solution-oriented, gives honest feedback, and consistently pushes the team to perform at a higher level. Working under him raised my own standard.',
  },
  {
    id: 2,
    name: 'Farooq Ogunfuyi',
    role: 'MS SCM',
    relation: 'December 17, 2025, Farooq was Jeff\'s client',
    endorsement:
      'Jeff was instrumental in my early career development and played a major role in creating and properly leveraging LinkedIn as a professional platform. He shared real world market insight, strategic guidance, and practical advice on how to position myself, communicate my value, and navigate opportunities within the industry. Jeff helped to change my outlook by gaining clarity on how to approach my career more intentionally. His guidance directly influenced the opportunities I pursued, and even lead me to secure my role at Boeing. What sets Jeff apart is that his advice isn\'t theoretical — it\'s based on experience, awareness of the market, and a genuine desire to see others succeed. Jeff consistently shows up and is genuine when it comes to working with people, as well as solutions for their concerns. I\'m grateful for his guidance and would strongly recommend him to anyone looking for honest career insight, leadership, and real results.',
  },
  {
    id: 3,
    name: 'Bucky Brown',
    role: 'Director at Arnold Construction | Pipeline Integrity Solutions',
    relation: 'November 14, 2025, Bucky was Jeff\'s client',
    endorsement:
      'I highly recommend MainFrame Solutions for any business looking to elevate their online presence. Their team combines strong technical expertise with excellent communication and a genuine commitment to understanding their clients\' goals. From the initial planning stages to final delivery, they were responsive, transparent, and proactive — making the entire process smooth and stress-free.',
  },
  {
    id: 4,
    name: 'Bryan Walker',
    role: 'Project Manager',
    relation: 'October 27, 2025, Bryan was Jeff\'s client',
    endorsement:
      'I had the pleasure of working with Jeff Dume during my recent job search, and I can confidently say he\'s one of the best recruiters I\'ve worked with. From our first conversation, Jeff was professional, transparent, and genuinely invested in finding the right fit for my skills and career goals. He took the time to understand what I was looking for, provided thoughtful guidance throughout the process, and kept me updated every step of the way. Jeff\'s communication skills, industry knowledge, and ability to match candidates with the right opportunities truly set him apart. Thanks to his support, I landed a role that aligns perfectly with my experience and aspirations. I highly recommend Jeff to anyone seeking a dedicated and results-driven recruiter who truly cares about the people he works with.',
  },
  {
    id: 5,
    name: 'Jose Loza',
    role: 'Construction Management Professional',
    relation: 'September 2, 2025, Jose was Jeff\'s client',
    endorsement:
      'I highly recommend Jeff Dum&eacute; for his exceptional professionalism, dedication, and work ethic. He consistently goes above and beyond in every task, ensuring that not only is the job completed on time, but also to the highest standard. His attention to detail and willingness to put in the extra effort set him apart. Jeff is the kind of person who doesn\'t just meet expectations, he exceeds them. Any team would be fortunate to have someone with his drive, reliability, and commitment to excellence.',
  },
  {
    id: 6,
    name: 'Adam Foulkrod',
    role: 'Senior Construction Administration Lead at Arup',
    relation: 'June 19, 2025, Adam was Jeff\'s client',
    endorsement:
      'Jeff helped me find a new job with a better schedule as well as a higher salary. He communicated with me as much as necessary and also negotiated well on my behalf to help increase the initial offer. He\'s met with me and stayed in touch after I accepted the offer to make sure it\'s a great fit! Jeff is very kind and personable, easy to work with and will keep looking for the right fit for you not just a job.',
  },
  {
    id: 7,
    name: 'Joe Hernandez, CHST',
    role: 'Safety Director',
    relation: 'May 29, 2025, Joe was Jeff\'s client',
    endorsement:
      'I highly recommend Jeff as your professional recruiter — he had me placed at my current role within a week. He negotiated my salary and got me started within a week.',
  },
  {
    id: 8,
    name: 'Michael Johnson, PMP',
    role: 'Construction',
    relation: 'May 22, 2025, Michael was Jeff\'s client',
    endorsement:
      'Big thanks to Jeff for helping me land my current role as Director of Construction. From day one, he was easy to talk to, understood exactly what I was looking for, and didn\'t waste my time with roles that didn\'t fit. What really stood out was how involved he stayed through the whole process — always checking in, offering honest advice, and making sure things moved smoothly. You can tell he genuinely cares about placing the right people in the right positions. If you\'re in construction and looking to level up, Jeff\'s the guy you want in your corner.',
  },
  {
    id: 9,
    name: 'Nicole Horst',
    role: 'Cost Estimator',
    relation: 'April 9, 2025, Nicole was Jeff\'s client',
    endorsement:
      'I am writing to offer my highest recommendation for Jeff, who played an instrumental role in helping me secure my current position. From the beginning of the job search process, Jeff demonstrated exceptional professionalism, attention to detail, and an unwavering commitment to understanding my career goals and aspirations.',
  },
  {
    id: 10,
    name: 'Jorge Sandoval',
    role: 'Assistant Project Manager | Persons Services Corp',
    relation: 'March 3, 2025, Jorge was Jeff\'s client',
    endorsement:
      'I want to sincerely thank Jeff for his invaluable support in helping me secure a role as a Junior Estimator. From the very beginning, Jeff took the time to understand my background, skills, and career goals, and he guided me through every step of the process. His advice and expertise gave me the confidence to present myself in the best possible way, and his consistent communication ensured I was always prepared. Jeff\'s dedication and commitment to my success truly made a difference, and I couldn\'t have asked for a better recruiter during this career transition. I highly recommend Jeff to anyone looking for professional guidance and career support — his knowledge and willingness to go the extra mile are unmatched.',
  },
  {
    id: 11,
    name: 'Clare Metz, PMP',
    role: 'PMP',
    relation: 'March 3, 2025, Clare was Jeff\'s client',
    endorsement:
      'I\'d absolutely recommend Jeff to anyone seeking career advancement. Jeff was incredibly knowledgeable and helpful in my success in finding my current position.',
  },
  {
    id: 12,
    name: 'Kade Kramr',
    role: 'Project Manager at Reytec Construction Resources',
    relation: 'February 19, 2025, Kade was Jeff\'s client',
    endorsement:
      'It was a pleasure to work with Jeff and he found the perfect opportunity for me with very little effort on my end. I highly recommend his services to anyone looking to make a career change!',
  },
  {
    id: 13,
    name: 'Brandon Del Villar',
    role: 'Project Manager @ Reytec Construction Resources | Construction Management',
    relation: 'February 12, 2025, Brandon was Jeff\'s client',
    endorsement:
      'Couldn\'t recommend Jeff enough on his great help, he definitely worked hand in hand with me to find placement within a company that will further my experience. 10/10',
  },
  {
    id: 14,
    name: 'Marvin Lopez',
    role: 'Concrete Estimator',
    relation: 'January 31, 2025, Marvin was Jeff\'s client',
    endorsement:
      'I highly recommend Jeff for anyone seeking to advance their career. From our initial conversation, he quickly understood my career goals and identified companies that aligned with my values and aspirations. He provided me with multiple excellent opportunities to consider, and couldn\'t be more satisfied with the outcome. If you\'re looking to make a meaningful change in your career, Jeff is the expert you want by your side. Thanks again Jeff.',
  },
  {
    id: 15,
    name: 'Jonathan Schnacke',
    role: 'Chief Estimator at Texas Dewatering',
    relation: 'January 26, 2025, Jonathan was Jeff\'s client',
    endorsement:
      'I am thrilled to recommend Jeff, who played a pivotal role in my career by placing me in my current position. From our very first conversation, it was clear that Jeff is dedicated, knowledgeable, and genuinely invested in finding the right fit for both candidates and employers. What stands out about Jeff is his commitment to building lasting relationships. Over the years, we\'ve kept in touch, and I have always appreciated his respectful and supportive approach. Jeff took the time to understand my career goals, skills, and aspirations, providing valuable insights throughout the process. Jeff\'s professionalism and attention to detail made the entire experience seamless and enjoyable. I felt supported at every stage, from the initial interview prep to the final offer negotiation. Thanks to Jeff\'s expertise and efforts, I am now in a role that aligns perfectly with my career ambitions. I highly recommend Jeff to anyone seeking a talented and committed recruiter who truly cares about their clients and candidates alike.',
  },
  {
    id: 16,
    name: 'Bo Hayes',
    role: 'Estimator/Project Manager',
    relation: 'January 24, 2025, Bo was Jeff\'s client',
    endorsement:
      'Jeff was great to work with. He was knowledgeable in the company he was representing, communicative, and punctual. He got me an interview and was available for any and all follow up. He really made the whole process quick and painless. I would highly recommend him to anyone!',
  },
  {
    id: 17,
    name: 'Ayan Nasir',
    role: 'Engineering & Construction | Data Center Development',
    relation: 'December 16, 2024, Ayan was Jeff\'s client',
    endorsement:
      'Working with Jeff was great, very smooth and communicative. His deep understanding of the field, personalized guidance, and dedication made the process seamless and efficient. I highly recommend Jeff to anyone looking for a recruiter who truly delivers results.',
  },
  {
    id: 18,
    name: 'Jorge Rojas',
    role: 'Shop Coordinator',
    relation: 'December 4, 2024, Jorge was Jeff\'s client',
    endorsement:
      'Working with Jeff has been great, from start to finish he has done an amazing job. I would highly recommend him, his expertise, knowledge and skills are what makes him great. You are in really good hands when dealing with him, no doubt about it.',
  },
  {
    id: 19,
    name: 'Marlon Black',
    role: 'Project Estimator at Pate Garver, LP',
    relation: 'October 24, 2024, Marlon was Jeff\'s client',
    endorsement:
      'Jeff showcases all qualities of both professionalism and compassion to those looking for assignment into a new role. It was a pleasure working with Jeff and I would highly recommend anyone seeking a new fit to contact him as soon as possible. Thanks again and can\'t wait to see all your future success.',
  },
  {
    id: 20,
    name: 'Ryan Andreasen',
    role: 'Estimator at Persons Services Corp.',
    relation: 'October 23, 2024, Ryan was Jeff\'s client',
    endorsement:
      'Working with Jeff was a pleasure. Communication was excellent and we were able to find the right company for me to transition to.',
  },
  {
    id: 21,
    name: 'Christopher Dean',
    role: 'Underground Utilities',
    relation: 'October 23, 2024, Christopher was Jeff\'s client',
    endorsement:
      'Jeff is a great recruiter! Easy to work with and does an awesome job. Would definitely recommend him for anyone looking for a construction job!',
  },
  {
    id: 22,
    name: 'Nicolas Suarez',
    role: 'Owner | Parking Lot Striping & Sign Installation Specialist',
    relation: 'October 23, 2024, Jeff was Nicolas\'s client',
    endorsement:
      'Very receptive and knowledgeable with company structures and atmospheres.',
  },
  {
    id: 23,
    name: 'Andrew Klippert',
    role: 'Environmental Investigator | Regulatory Compliance | Client Relations Management',
    relation: 'September 9, 2024, Andrew was Jeff\'s client',
    endorsement:
      'As a client of Jeff, I would strongly recommend him to anyone looking to fill or find a role. He is professional, timely, and has a wealth of connections. I\'d work with him again in a heartbeat!',
  },
  {
    id: 24,
    name: 'Juan Valadez Jr',
    role: 'Project Manager at Odin Environmental Solutions, LLC',
    relation: 'August 6, 2024, Jeff was Juan\'s client',
    endorsement:
      'Jeff assisted myself in securing my new position with the company I\'ve joined. Jeff\'s dedication, professionalism, and expertise played a crucial role in my successful job search and I\'m grateful for his support. From our initial interaction, it was evident that Jeff possessed an in depth understanding of the industry and was committed to helping me find the best opportunity. Jeff\'s insights in the market, combined with his personalized approach, made a significant difference in my job search. Jeff took the time to understand my career goals, skills and preferences and matched me with a position that aligns myself for a better overall future in my career path and offered a highly competitive compensation package with excellent benefits. His expertise and guidance provided me with the confidence and preparation I needed to succeed in my interviews with my new company. Truly thankful. Jeff comes highly recommended due to his personalized efforts which will help me grow professionally. Jeff\'s expertise, professionalism, and genuine care for his clients sets him apart as an outstanding recruiter. Once again, thank you for your support and for making this transition a positive and rewarding experience.',
  },
  {
    id: 25,
    name: 'Vanessa Moreno',
    role: 'Estimator II at Webber Waterworks',
    relation: 'August 1, 2024, Vanessa was Jeff\'s client',
    endorsement:
      'I highly recommend Jeff for any job search or hiring needs. He is an exceptional recruiter with a keen eye for talent and a great understanding of the industry. Jeff is not only professional and reliable, but also goes above and beyond to ensure a seamless hiring process. Thank you Jeff.',
  },
  {
    id: 26,
    name: 'Cody Williams',
    role: 'General Superintendent Hayden Paving',
    relation: 'July 7, 2024, Cody was Jeff\'s client',
    endorsement:
      'Jeff Dume did an outstanding job making all things work for myself and Hayden Paving during the hiring process. I, Cody Williams, would definitely use Jeff again if needing to make a change.',
  },
  {
    id: 27,
    name: 'Alberto Reyes',
    role: 'Project Superintendent at Harper Brothers Construction',
    relation: 'June 25, 2024, Alberto was Jeff\'s client',
    endorsement:
      'If you\'re in need of a new opportunity or simply looking for new opportunities to progress in your career, please reach out to Jeff Dume. From my personal experience with his assistance I know without a doubt he will jump on and assist you in any way possible and quickest way possible. Professional, Reliable and with you through the whole process. Thank you Jeff for your dedication on what you do.',
  },
  {
    id: 28,
    name: 'Scott Cormier',
    role: 'Owner/President Triple C | Cormier Civil Constructors',
    relation: 'June 19, 2024, Scott was Jeff\'s client',
    endorsement:
      'I recommend Jeff Dume for all your needs as a recruiter, he was very diligent, very helpful and persistent on helping me land a great position. Let him work for you as he worked for me.',
  },
  {
    id: 29,
    name: 'Stephen Lafferman',
    role: 'Account Manager at Penhall Company',
    relation: 'May 31, 2024, Stephen worked with Jeff on the same team',
    endorsement:
      'I have worked with Jeff over 3 years. He is a motivated professional with a drive to succeed. He prides himself on personal development and customer satisfaction. He is an asset to anyone who meets him personally and professionally.',
  },
  {
    id: 30,
    name: 'Pablo Paz',
    role: 'Construction Professional',
    relation: 'May 16, 2024, Pablo was Jeff\'s client',
    endorsement:
      'Jeff is great at what he does! I went to him as a client and he was able to lead the way to have new opportunities handed to me. I definitely recommend him if you\'re looking for new experiences and opportunities.',
  },
  {
    id: 31,
    name: 'Jerry Castro',
    role: 'Earthwork Estimator',
    relation: 'March 5, 2024, Jerry was Jeff\'s client',
    endorsement:
      'It was a real pleasure working with Jeff. He communicated effectively from interview to offer and made sure I was updated on every aspect. If you\'re ever in the job market, do yourself a favor and reach out to Jeff.',
  },
  {
    id: 32,
    name: 'John Nunez',
    role: 'Project Estimator',
    relation: 'February 20, 2024, John was Jeff\'s client',
    endorsement:
      'If there is one man I recommend for the job, it would be Jeff! He was persistent on getting me leads, and was always on top with interviews. He is a very professional gentleman and always kept communication lines open. Thank you, Jeff.',
  },
  {
    id: 33,
    name: 'Wyatt McBeth',
    role: 'Construction Professional',
    relation: 'February 16, 2024, Wyatt was Jeff\'s client',
    endorsement:
      'Jeff took the time to deeply discuss my motivations and personality to match me with a company that reflects and appreciates my worth. I\'m very appreciative of Jeff\'s cooperation with finding my next venture.',
  },
  {
    id: 34,
    name: 'Robert Stefaniak',
    role: 'Estimator',
    relation: 'February 12, 2024, Jeff was Robert\'s client',
    endorsement:
      'Jeff did a great job of finding companies that were hiring. He also gathered information about the companies and gave me references to call to help get a feel for the companies culture. On top of getting the first contact to the companies he helped organize the interviews, give feedback and negotiate for the best possible salary.',
  },
  {
    id: 35,
    name: 'Estela Arroyo',
    role: 'Project Engineer | FHWA & TxDOT Infrastructure | P6 Scheduling & Construction Management',
    relation: 'February 12, 2024, Jeff was Estela\'s client',
    endorsement:
      'I would definitely recommend Jeff to anyone. He has a lot of insight and experience in the market. Jeff was a great listener and communicator. I have used recruiters in the past I can tell Jeff goes above and beyond to exceed expectations. He was always timely in responding to phone calls or emails and was thorough in explaining anything I had questions about. I would definitely recommend Jeff to any of my colleagues or connections.',
  },
  {
    id: 36,
    name: 'Cesar Cebrian',
    role: 'Electrical Engineer at Webber',
    relation: 'January 26, 2024, Cesar was Jeff\'s client',
    endorsement:
      'It is rare to come across someone as dedicated and hardworking as Jeff. Their commitment to their work and willingness to go the extra mile set them apart from everyone.',
  },
  {
    id: 37,
    name: 'Shaun Wilkerson',
    role: 'Project Manager',
    relation: 'January 25, 2024, Shaun was Jeff\'s client',
    endorsement:
      'I worked with Jeff closely as he was finding the exact right fit for me. He provided me with several options during the search. He is very knowledgeable about his clients and provided insights as to which client he thought would be the employer that would match me perfectly. I highly recommend Jeff as both an employer and as a candidate for employment.',
  },
  {
    id: 39,
    name: 'Anthony Hardimon',
    role: 'Sr Project Engineer',
    relation: 'January 18, 2024, Anthony was Jeff\'s client',
    endorsement:
      'Working with Jeff was an absolute pleasure. He remained consistent, and worked effortlessly to place me with the right company. Jeff took his time to do his research on the companies, and he only sent the ones that he felt would be a good fit. I accepted an amazing role at a great company thanks to Jeff!',
  },
  {
    id: 40,
    name: 'Kurt Roedel',
    role: 'Construction Professional',
    relation: 'January 17, 2024, Kurt was Jeff\'s client',
    endorsement:
      'Jeff was very knowledgeable around the specialty space that is the construction world. Instead of having to waste time, he actively brought great leads my way and quickly. Thanks again Jeff, great working with you.',
  },
  {
    id: 41,
    name: 'Rodrigo Velasquez',
    role: 'Construction Professional',
    relation: 'September 8, 2023, Rodrigo was Jeff\'s client',
    endorsement:
      'Highly recommended Jeff — this guy here got me a great opportunity with Brice Civil and can\'t thank him enough for it.',
  },
  {
    id: 42,
    name: 'Darius Deese',
    role: 'B.S. Construction Management | Assistant Superintendent',
    relation: 'August 3, 2023, Jeff was Darius\'s client',
    endorsement:
      'Jeff was very helpful in my job search. He\'s very knowledgeable in his field and a great guy.',
  },
  {
    id: 43,
    name: 'Ibrahim Idris',
    role: 'Project Engineer at Lane Construction (webuild)',
    relation: 'May 26, 2023, Ibrahim was Jeff\'s client',
    endorsement:
      'I want to express my gratification for Jeff and his service. Not only was he a persistent and well-mannered recruiter, he made sure that I was informed every step before, during and after my process. He cared to understand my needs and made sure I was happy. Thank you for your hard work.',
  },
  {
    id: 44,
    name: 'Veronica Ortiz',
    role: 'Senior Project Coordinator at O\'Donnell Snider Construction',
    relation: 'March 27, 2023, Veronica was Jeff\'s client',
    endorsement:
      'Jeff is absolutely amazing!! As a single mom that is sole provider, being unexpectedly laid off from one day to the next was a very scary time for me. Jeff went above and beyond to help me. I will forever be grateful!! I recommend Jeff 100% — he truly has your best interest at heart.',
  },
  {
    id: 45,
    name: 'Charlie Matto',
    role: 'Construction Estimator at SpawGlass',
    relation: 'March 27, 2023, Charlie was Jeff\'s client',
    endorsement:
      'Jeff is more than just your average recruiter. He is determined to find the perfect job and workplace for you to continue your career. During the job hunting process, Jeff will call, text, and email you updates as often as you want them, whether that is multiple times a day or just a few times a week. Jeff keeps the line of clear communication between you, himself, and your next potential employer by checking in with you after every interview and following up with the employer for next steps. He will fight on your behalf to make sure you get exactly what you want out of your next job. Whether you are looking for a career change, better pay, or just a change of scenery, Jeff is the one recruiter you can rely on to make that happen.',
  },
  {
    id: 46,
    name: 'Andrew Bujanos',
    role: 'Project Manager @ Highway Intelligent Traffic Solutions, LLC | Engineering, Project Management',
    relation: 'March 25, 2023, Andrew was Jeff\'s client',
    endorsement:
      'I wanted to take a moment to express my deepest appreciation for the incredible support and assistance you provided me in finding an engineering job in Tampa, Florida. Your intelligence, compassion, and dedication to my success were truly unparalleled, and I am forever grateful for everything you did for me.',
  },
];

export const memberships = [
  {
    id: 1,
    name: 'Microsoft Partner Ecosystem',
    role: 'Member',
    period: 'May 2026 – Present',
    association: 'Mainframe Solutions',
    description:
      'Contributing to the Microsoft partner ecosystem to deliver cloud solutions, AI governance, and enterprise software infrastructure to organizations navigating growth and digital transformation.',
  },
  {
    id: 2,
    name: 'Regional Hispanic Contractors Association (RHCA)',
    role: 'Member',
    period: 'May 2026 – Present',
    association: 'Mainframe Solutions',
    description:
      'Contributing to conversations around workforce development, safety, and responsible AI adoption within the construction industry.',
  },
  {
    id: 3,
    name: 'AGC of Texas',
    role: 'Member',
    period: 'Jan 2026 – Present',
    association: 'Mainframe Solutions',
    description:
      'Supporting construction and infrastructure organizations through workforce strategy, executive search, and operational systems aligned with industry standards.',
  },
  {
    id: 4,
    name: 'Houston Contractors Association',
    role: 'Member',
    period: 'Jan 2026 – Present',
    association: 'Mainframe Solutions',
    description:
      'Engaging with Houston-area construction leaders on workforce development, operational excellence, and leadership pipeline planning.',
  },
  {
    id: 5,
    name: 'Society for Human Resource Management',
    role: 'Member',
    period: 'Dec 2025 – Present',
    association: 'Mainframe Solutions',
    description:
      'Staying connected to national HR best practices, compliance standards, and workforce policy developments that inform BuildFit AI and Mainframe Solutions advisory work.',
  },
  {
    id: 6,
    name: 'HR Houston',
    role: 'Member',
    period: 'Dec 2021 – Present',
    association: 'Mainframe Solutions',
    description:
      'Active member and speaker at HR Houston events, contributing to regional workforce conversations around structured hiring, AI governance, and leadership development.',
  },
];